import { Route, Routes } from 'react-router-dom';

import { GuardScope, useAccessGuard } from '@web/app/shared';
import { DefaultLayout2 } from '@web/app/shared/components/default-layout';

import { OpenApiKeysPage } from '../pages';

export const OpenApiKeysRoutes = () => {
    useAccessGuard(GuardScope.Workspace);

    return (
        <Routes>
            <Route element={<DefaultLayout2 />}>
                <Route path="/" element={<OpenApiKeysPage />} />
                <Route path="/:keyId" element={<OpenApiKeysPage />} />
            </Route>
        </Routes>
    );
};
